var chunkToChildrenMap = {
	"src_components_panels_add-fancytext-panel_index_ts": [
		"src_components_panels_add-fancytext-color-panel_index_ts-_49071"
	],
	"src_components_contextual-menu_components_bottom-bar-item_index_ts-src_components_panels_time-fe452a": [
		"vendors-node_modules_emoji-picker-react_dist_emoji-picker-react_esm_js",
		"vendors-node_modules_react-voice-visualizer_dist_react-voice-visualizer_js",
		"src_components_editor-brands_index_ts",
		"src_components_tabs_components_more-tabs-dropdown_index_ts-src_components_tabs_components_mor-523008",
		"src_components_list_index_ts",
		"src_components_base-masonry-grid_index_ts",
		"src_components_ai-text-prompt-box_index_tsx",
		"src_components_panels_stock-panel_components_stock-panel-grid_index_ts",
		"src_components_panels_record-image-and-video-panel_components_video-playback_index_ts",
		"src_components_panels_stock-panel_index_ts-src_components_panels_stock-panel_components_stock-c64c19",
		"src_components_panels_record-image-and-video-panel_components_image-and-video-recorder-contro-df1ed5",
		"src_components_panels_stock-panel_components_ai-image-filter-pop-up_index_ts-src_components_p-75e78b",
		"src_components_text-to-image-grid_index_ts-src_components_base-masonry-grid_base-masonry-grid-b05f7a",
		"src_components_panels_record-image-and-video-panel_components_record-image-and-video-panel-co-c3cb25",
		"src_components_panels_user-media-panel_components_upload-button-section_index_ts",
		"src_components_panels_record-image-and-video-panel_index_ts",
		"src_components_panels_ai-voice-panel_ai-voice-panel_tsx",
		"src_components_panels_user-media-panel_components_media-section_index_ts",
		"src_components_panels_user-media-panel_components_upload-and-social-media-section_index_ts",
		"src_components_panels_user-media-panel_components_facebook-media-section_index_ts",
		"src_components_panels_record-audio-panel_index_ts",
		"src_components_panels_user-media-panel_components_media-panel-footer_index_ts",
		"src_components_panels_user-media-panel_index_ts-src_components_panels_record-audio-panel_comp-7cf3f4",
		"src_components_media-control-buttons_components_play-pause-button_index_ts-src_components_mod-a333e2",
		"vendors-node_modules_postermywall_react-colorful_dist_index_mjs",
		"src_components_color-picker-v2_components_hex-picker_index_ts-src_components_color-picker-v2_-bef5a3",
		"src_components_panels_poster-editor-color-panel_index_ts",
		"src_components_panels_poster-editor-item-list-panel_components_base-unordered-list-thumbnails-3a9416",
		"src_components_panels_poster-editor-item-list-panel_components_base-list-mobile-options_index_ts",
		"src_components_color-picker-mobile_components_default-preset-section_index_ts-src_components_-2b71a8",
		"src_components_panels_poster-editor-item-list-panel_index_ts",
		"src_components_color-picker-mobile_components_default-preset-section_default-preset-section_m-e8693c",
		"src_components_panels_poster-editor-text-fill-panel_components_base-fill-type-options_index_ts",
		"src_components_color-picker-mobile_components_default-preset-section_index_ts-src_components_-f62b88",
		"src_components_panels_poster-editor-text-fill-panel_index_ts",
		"src_components_color-picker-mobile_components_default-preset-section_default-preset-section_m-a5b52b",
		"src_components_panels_poster-editor-item-shadow-panel_components_base-mobile-shadow-options_i-d95bf4",
		"src_components_poster-editor_components_poster-editing-side-panel_components_base-item-custom-39271a",
		"src_components_panels_poster-editor-item-shadow-panel_index_ts",
		"src_components_color-picker-mobile_components_default-preset-section_index_ts-src_components_-b274a2",
		"vendors-node_modules_howler_dist_howler_js",
		"src_poster-whiteboard_classes_item-effects_class_ts",
		"src_poster-whiteboard_items_tabs-item_tabs-item_class_ts",
		"src_poster-whiteboard_items_image-item_image-item_class_ts",
		"src_poster-whiteboard_items_item_item-factory_ts",
		"src_components_poster-editor_components_poster-editing-side-panel_components_slideshow-intro--474a80",
		"src_components_panels_poster-editor-slideshow-slides-panel_index_ts-src_hooks_poster-editor_u-a564941",
		"src_components_panels_poster-editor-item-background-panel_components_textslide-background-pan-bdd969",
		"src_components_panels_poster-editor-item-background-panel_index_ts",
		"src_components_color-picker-mobile_components_default-preset-section_index_ts-src_components_-b1b1c2",
		"src_components_contextual-menu_components_contextual-menu-horizontal-scrolling-section_index_-8ea62c",
		"src_components_panels_poster-editor-slideshow-transition-panel_index_ts",
		"src_components_color-picker-mobile_components_default-preset-section_index_ts-src_components_-da4293",
		"src_components_panels_poster-editor-text-outline-panel_index_ts",
		"src_components_color-picker-mobile_components_default-preset-section_index_ts-src_components_-bd77bb",
		"vendors-node_modules_fuse_js_dist_fuse_esm_js",
		"src_components_font-selector-panel_index_ts",
		"src_components_poster-editor_components_poster-editing-side-panel_components_text-item-font-s-343891",
		"src_components_panels_poster-editor-text-item-font-panel_index_ts-src_hooks_poster-editor_use-2464d7",
		"src_components_poster-editor_components_poster-editing-side-panel_components_item-alignment-o-ca34a8",
		"src_components_contextual-menu_components_contextual-menu-styling-option_index_ts-src_compone-ec0156",
		"src_components_poster-editor_components_poster-editing-side-panel_components_spellcheck-conte-568177",
		"src_components_contextual-menu_components_contextual-menu-heading-option_index_ts-src_compone-d27645",
		"src_components_panels_poster-editor-item-font-style-panel_index_ts",
		"src_components_contextual-menu_components_contextual-menu-thumbnail-item_index_ts-src_compone-9ba14e",
		"src_components_poster-editor_components_poster-editing-side-panel_components_item-size-option-984a14",
		"src_components_panels_poster-editor-item-font-size-panel_index_ts-src_hooks_poster-editor_use-9ff422",
		"src_components_panels_poster-editor-item-letter-spacing-panel_index_ts-_f7de1",
		"src_components_panels_poster-editor-edit-text-panel_index_ts-_3bd31",
		"src_components_panels_poster-editor-item-line-height-panel_index_ts-_0a1c1",
		"src_components_panels_poster-editor-slideshow-apply-properties-panel_index_ts-_bdbb0"
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));